export default __webpack_public_path__ + "static/pharmacy-management-system-development-8bf471cbf8af305e2f6745a843329ebe.jpg";